import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import useColors from "../../api/hooks/useColors";
import CustomToolTip from "../CustomTooltip";

const ViewedTodayTooltip = () => {
  const colors = useColors();

  return (
    <CustomToolTip title="This control has already been viewed today">
      <VisibilityRoundedIcon sx={{ width: "28px", color: colors.grey_600 }} />
    </CustomToolTip>
  );
};

export default ViewedTodayTooltip;
